import { render, staticRenderFns } from "./cogsSvg.vue?vue&type=template&id=77980eb2"
import script from "./cogsSvg.vue?vue&type=script&lang=js"
export * from "./cogsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports